export default "__VITE_ASSET__BU72TYUV__"